import { UserCircleIcon } from "@heroicons/react/24/outline";
import { Accordion } from "@via/components/accordion/accordion";
import { addUserGroupMemberOptions } from "@via/utils/form-validators";
import { type JSX } from "react";
import { useForm } from "react-hook-form";
import { useAddProjectBucketMember } from "@via/pages/projects/project-bucket.api.tsx";
import FormInputComponent from "@via/components/inputs/form-input-component";

export default function AddBucketMember({
  projectId,
}: {
  projectId: number;
}): JSX.Element {
  const { control, handleSubmit } = useForm<{
    memberEmail: string;
  }>({
    mode: "onChange",
  });

  const {
    mutateAsync: addProjectBucketMember,
    isPending: isAddProjectBucketMemberLoading,
  } = useAddProjectBucketMember();

  const handleAddProjectBucketMember = async (payload: {
    memberEmail: string;
  }) => {
    await addProjectBucketMember({ projectId, ...payload });
  };

  return (
    <Accordion title="Add New Member">
      <form
        onSubmit={e => {
          e.preventDefault();
          void handleSubmit(handleAddProjectBucketMember)(e);
        }}>
        <FormInputComponent
          control={control}
          name="memberEmail"
          label="Email"
          placeholder="Enter email"
          validations={addUserGroupMemberOptions.email}
          showRequiredField
        />
        <div className="flex justify-end mt-2">
          <button
            disabled={isAddProjectBucketMemberLoading}
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            <UserCircleIcon className="-ml-1 mr-1 h-5 w-5" aria-hidden="true" />
            Add Member
          </button>
        </div>
      </form>
    </Accordion>
  );
}
